var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScheduleSessionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "62px",
    viewBox: "0 0 58 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M34,26.4 C38.6308,26.4 42.4,30.168 42.4,34.8 C42.4,35.4624 41.8636,36 41.2,36 L41.2,36 L26.8,36 C26.1364,36 25.6,35.4624 25.6,34.8 C25.6,30.168 29.3692,26.4 34,26.4 Z M34,14.4 C36.6472,14.4 38.8,16.5528 38.8,19.2 C38.8,21.8472 36.6472,24 34,24 C31.3528,24 29.2,21.8472 29.2,19.2 C29.2,16.5528 31.3528,14.4 34,14.4 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,26.1333333 C27.2692857,26.1333333 34,32.832 34,41.0666667 C34,42.2442667 33.0421429,43.2 31.8571429,43.2 L31.8571429,43.2 L6.14285714,43.2 C4.95785714,43.2 4,42.2442667 4,41.0666667 C4,32.832 10.7307143,26.1333333 19,26.1333333 Z M19,4.8 C23.7271429,4.8 27.5714286,8.6272 27.5714286,13.3333333 C27.5714286,18.0394667 23.7271429,21.8666667 19,21.8666667 C14.2728571,21.8666667 10.4285714,18.0394667 10.4285714,13.3333333 C10.4285714,8.6272 14.2728571,4.8 19,4.8 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.36372,17.0526316 C16.36372,17.808 15.7527734,18.4210526 15,18.4210526 C14.2472266,18.4210526 13.63628,17.808 13.63628,17.0526316 L13.63628,11.5789474 C13.63628,10.8235789 14.2472266,10.2105263 15,10.2105263 C15.7527734,10.2105263 16.36372,10.8235789 16.36372,11.5789474 L16.36372,17.0526316 Z M15,22.5263158 C14.2472266,22.5263158 13.63628,21.9132632 13.63628,21.1578947 C13.63628,20.4025263 14.2472266,19.7894737 15,19.7894737 C15.7527734,19.7894737 16.36372,20.4025263 16.36372,21.1578947 C16.36372,21.9132632 15.7527734,22.5263158 15,22.5263158 L15,22.5263158 Z M29.4022471,21.5725263 L18.9397871,4.16757895 C18.1229188,2.81010526 16.6501012,2 15,2 C13.3498988,2 11.8770812,2.81010526 11.0602129,4.16757895 L0.597752893,21.5725263 C-0.176840077,22.8629474 -0.200023318,24.4147368 0.536385492,25.7229474 C1.32597938,27.1283158 2.8601644,28 4.53754002,28 L25.46246,28 C27.1398356,28 28.6740206,27.1283158 29.4636145,25.7229474 C30.2000233,24.4147368 30.1768401,22.8629474 29.4022471,21.5725263 L29.4022471,21.5725263 Z",
    id: "path-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--Hub---Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CL---Hub---Change-Schedule--Data-error---Mob",
    transform: "translate(-159.000000, -180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(159.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-filled-/-tutor-session",
    transform: "translate(10.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\uD83C\\uDFA8-Icon-\\u0421olor",
    fill: "#FF6600",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\uD83C\\uDFA8-Icon-\\u0421olor",
    fill: "#FF6600",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon-/-filled-/-alert---exclamation"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\uD83C\\uDFA8-Icon-\\u0421olor",
    fill: "#F6A11D",
    xlinkHref: "#path-5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleSessionIcon);
export default __webpack_public_path__ + "static/media/schedule-session-icon.53c34edc0f696f716b3d3d23f9128621.svg";
export { ForwardRef as ReactComponent };